import styled from 'styled-components';

export const ChartSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ChartSectionDivider = styled.div`
  border-bottom: 1px dashed ${({ theme }) => theme.neutralBorder};
  margin-bottom: 24px;
`;

export const DataVizContainer = styled.div`
  max-height: 416px;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;

  padding-right: 20px;
`;
